import React, { FC, memo } from 'react';

import Helmet from 'react-helmet';

import { BRANDING_PROFILE } from '@/config/branding';

const DEFAULT_TITLE = BRANDING_PROFILE.productName;

interface TitleProps {
    title: string;
}

const TabTitle: FC<TitleProps> = ({ title }) => (
    <Helmet>
        <title>{title ? `${title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE}</title>
    </Helmet>
);

export default memo(TabTitle);
